import { checkTimer, getSession, isLoggedIn } from "@/utils/auth";
import { BASIC, CLASSIC, ENTERPRISE, ESSENTIAL, PRO, SECONDARY, SPOT, SPOT_CON } from "@/utils/clientTypes";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Login",
        alias: ["/login", "login"],
        component: () => import("@/views/login/Login.vue"),
    },
    {
        path: "/login-as-other-user",
        name: "Login as other user",
        component: () => import("@/views/login/Login.vue"),
        props: () => {
            return { isAnalist: true }
        }
    },
    {
        path: "/create-another-user/:uuid",
        name: "Create another user for an existing company",
        component: () => import("@/views/login/RegisterAnother.vue"),
    },
    {
        path: "/registerchita",
        name: "RegisterChita",
        component: () => import("@/views/login/RegisterChita.vue"),
    },
    {
        path: "/registerbasicfree",
        name: "RegisterBasic",
        component: () => import("@/views/login/RegisterFast.vue"),
        props: () => {
            return { type: BASIC }
        }
    },
    {
        path: "/registeressential",
        name: "RegisterEssential",
        component: () => import("@/views/login/RegisterFast.vue"),
        props: () => {
            return { type: ESSENTIAL }
        }
    },
    {
        path: "/registerenterprise",
        name: "RegisterEnterprise",
        component: () => import("@/views/login/RegisterFast.vue"),
        props: () => {
            return { type: ENTERPRISE }
        }
    },
    {
        path: "/recoveryconfirm",
        name: "RecoveryConfirm",
        component: () => import("@/views/login/RecoveryConfirm.vue"),
    },
    {
        path: "/recoverypassword",
        name: "RecoveryPassword",
        component: () => import("@/views/login/RecoveryPassword.vue"),
    },
    {
        path: "/changepassword/:token",
        name: "ChangePassword",
        component: () => import("@/views/login/ChangePassword.vue"),
    },
    {
        path: "/confirm",
        name: "Confirm",
        component: () => import("@/views/login/Confirm.vue"),
        props: (route) => Object.assign({}, route.query, route.params),
    },
    {
        path: "/thankyou",
        name: "Thankyou",
        component: () => import("@/views/login/Thankyou.vue"),
    },
    {
        path: "/go-to-plan",
        name: "Choose plan",
        meta: { requiresAuth: true },
    },
    {
        path: "/panel-analista",
        name: "panel-analista",
        component: () => import("@/views/PanelAnalista.vue"),
        meta: { requiresAuth: true, authRequired: [BASIC, CLASSIC, ENTERPRISE, PRO, SECONDARY, SPOT, SPOT_CON, ESSENTIAL] },
    },
    {
        path: "/info-company",
        name: "companyData",
        component: () => import("@/views/CompanyInfo.vue"),
        meta: { requiresAuth: true, authRequired: [BASIC, CLASSIC, ENTERPRISE, PRO, SECONDARY, SPOT, SPOT_CON, ESSENTIAL] },
        props: true,
    },
    {
        path: "/dashboard",
        name: CLASSIC,
        component: () => import("@/views/Dashboard.vue"),
        meta: { requiresAuth: true, authRequired: [CLASSIC, ESSENTIAL] },
    },
    {
        path: "/dashboard",
        name: BASIC,
        component: () => import("@/views/Dashboard.vue"),
        meta: { requiresAuth: true, authRequired: [BASIC] },
    },
    {
        path: "/dashboard",
        name: PRO,
        component: () => import("@/views/Dashboard.vue"),
        meta: { requiresAuth: true, authRequired: [PRO] },
    },
    {
        path: "/dashboard",
        name: ENTERPRISE,
        component: () => import("@/views/Dashboard.vue"),
        meta: { requiresAuth: true, authRequired: [ENTERPRISE] },
    },
    {
        path: "/dashboard",
        name: ESSENTIAL,
        component: () => import("@/views/Dashboard.vue"),
        meta: { requiresAuth: true, authRequired: [ESSENTIAL] },
    },
    {
        path: "/dashboard",
        name: SECONDARY,
        component: () => import("@/views/Dashboard.vue"),
        meta: { requiresAuth: true, authRequired: [SECONDARY] },
    },
    {
        path: "/plan-basic",
        redirect: '/dashboard',
    },
    {
        path: "/plan-essential",
        redirect: '/dashboard',
    },
    {
        path: "/plan-enterprise",
        redirect: '/dashboard',
    },
    {
        path: "/plan-pro",
        redirect: '/dashboard',
    },
    {
        path: "/filldata",
        name: "FillData",
        component: () => import("@/views/FillData.vue"),
        meta: { requiresAuth: true, authRequired: [ESSENTIAL, BASIC] },
    },
    {
        path: "/404",
        name: "Error404",
        component: () => import("@/views/errors/Error404.vue"),
    },
    {
        path: "*",
        name: "ErrorPage",
        component: () => import("@/views/errors/ErrorPage.vue"),
    },
];

const router = new VueRouter({
    routes,
});

router.beforeEach(async (to, from, next) => {
    checkTimer();
    const isLogged = await isLoggedIn();
    new SegmentAnalytics().page(to.name);
    if (isLogged) {
        let session = getSession();
        if (session) {
            if (to.name.startsWith("Register") || to.name === "Login") {
                console.log('login or register');
                next({
                    name: "Choose plan",
                });
            } else if (to.name === "Choose plan" || to.path === "/") {
                console.log('choose plan:', session.user.user_type);
                if (session.user.user_type == 'ANALISTA' && session.user.is_staff == true ) {
                    router.push({
                        name: 'panel-analista',
                    });
                    return;
                } else {
                    let existsRoute = routes.find(
                        (route) => route.name === session.user.client_type
                    );
                    if (existsRoute) {
                        router.push({
                            name: session.user.client_type,
                        });
                        return;
                    } else {
                        router.push({
                            name: "Error404",
                        });
                        return;
                    }
                }
            } else if (to.matched.some((record) => record.meta.requiresAuth)) {
                if (
                    session.user.user_type != 'ANALISTA' &&
                    to.meta.authRequired.indexOf(session.user.client_type) < 0
                ) {
                    next({
                        name: "Choose plan",
                    });
                } else {
                    next();
                }
            } else {
                next();
            }
        }
    } else if (to.matched.some((record) => record.meta.requiresAuth)) {
        next({
            path: "/",
            name: "Login",
            query: { redirect: "/" },
        });
    } else {
        next();
    }
});

export default router;
